import { render } from "./ProcurarDialog.vue?vue&type=template&id=6e216348"
import script from "./ProcurarDialog.vue?vue&type=script&lang=js"
export * from "./ProcurarDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__